import { Box, Checkbox, Grid, ListItemText, MenuItem, Paper, TextField, useTheme } from "@mui/material";
import { FC, useMemo, useState } from "react";
import { Property, PropertyValue } from "../api/dtos";
import { StyledDivider } from "../forms/inputs/CommonFormElements";
import useLotsByProjectIdStageId from "../hooks/data/useLotsByProjectIdStageId";
import usePostLotPropertyBulkEdit from "../hooks/data/usePostLotPropertyBulkEdit";
import { StyledButton } from "./StyledButton";
import { VirtualizedLotSelect } from "./VirtualizedPopper";

interface ILotPropertyBulkAssignPanelProps {
    projectId?: number;
    stageId?: number;
    properties: Property[];
}

const LotPropertyBulkAssignPanel: FC<ILotPropertyBulkAssignPanelProps> = ({
    projectId,
    stageId,
    properties = []
}) => {
    const theme = useTheme();
    const [selectedLots, setSelectedLots] = useState<number[]>([]);
    const [selectedProperties, setSelectedProperties] = useState<number[]>([]);
    const [propertyValues, setPropertyValues] = useState<{id: number, value: string}[]>([]);
    const {data: lots } = useLotsByProjectIdStageId(projectId, stageId);

    // const lotMap = useMemo(() => lots?.reduce<Record<number, Lot>>((state, lot) => {
    //     if (lot && lot.id && !state[lot.id]) {
    //         state[lot.id] = lot;
    //     }

    //     return state;
    // }, {}) ?? {}, [lots]);

    const propertyMap = useMemo(() => properties?.reduce<Record<number, Property>>((state, property) => {
        if (property && property.id && !state[property.id]) {
            state[property.id] = property;
        }

        return state;
    }, {}) ?? {}, [properties]);

    const submit = usePostLotPropertyBulkEdit();

    const handleSubmit = () => {
        const submitPropertyValues = selectedProperties.map((propertyId) => {
            return new PropertyValue({
                propertyId: propertyId,
                value: propertyValues[propertyValues.findIndex(x => x.id == propertyId)].value
            })
        }) as PropertyValue[];
        submit(selectedLots, submitPropertyValues);
    }
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center"
            }}
        >
            <Paper
                sx={{
                    width: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "75%",
                        xl: "50%"
                    },
                    marginTop: theme.spacing(2),
                    padding: theme.spacing(2)
                }}
            >
                <Grid
                    container
                    spacing={theme.spacing(2)}
                >
                    <Grid size={6}>
                        <VirtualizedLotSelect 
                            onChange={(selected: number[]) => setSelectedLots(selected)}
                            data={lots ?? []} 
                        />
                        {/* <TextField
                            fullWidth
                            label={"Lots"}
                            value={selectedLots}
                            variant="outlined"
                            select
                            slotProps={{
                                select: {
                                    multiple: true,
                                    MenuProps: {
                                        sx: {
                                            maxHeight: 500
                                        },
                                    },
                                    renderValue: (selected) => (selected as number[]).map(x => lotMap[x].number).join(','),
                                    onChange: (event) => {
                                        setSelectedLots(event.target.value as any)
                                    },
                                },
                            }}
                        >
                            {lots?.map(lot => {
                                return (
                                    <MenuItem>
                                        <Checkbox 
                                            checked={lot.id ? selectedLots.includes(lot.id) : false}
                                        />
                                        <ListItemText primary={lot.number} />
                                    </MenuItem>
                                );
                            })}
                        </TextField> */}
                    </Grid>
                    <Grid size={6}>
                        {/* <VirtualizedMultiLotPopperWindow data={lots ?? []} selectedIds={selectedLots} /> */}
                        <TextField
                            fullWidth
                            label={"Properties"}
                            value={selectedProperties}
                            variant="outlined"
                            select
                            slotProps={{
                                select: {
                                    multiple: true,
                                    MenuProps: {
                                        sx: {
                                            maxHeight: 500
                                        },
                                    },
                                    renderValue: (selected) => (selected as number[]).map(x => propertyMap[x].name).join(','),
                                    onChange: (event) => {
                                        setSelectedProperties(event.target.value as any);
                                        const targetAsNumArray = event.target.value as number[];
                                        let newPropertyValues = propertyValues;
                                        for(let i = newPropertyValues.length-1; i >= 0; i--) {
                                            const id = newPropertyValues[i].id;
                                            if(!targetAsNumArray.includes(id)) {
                                                newPropertyValues.splice(i, 1);
                                            }
                                        }
                                        (event.target.value as number[]).forEach(id => {
                                            const index = newPropertyValues.findIndex(x => x.id == id);
                                            if(index < 0) {
                                                newPropertyValues.push({id: id, value: ""});
                                            }
                                        });
                                    }
                                }
                            }}
                            >
                            {properties?.map(property => {
                                return (
                                    <MenuItem
                                        key={property.id}
                                        value={property.id}
                                    >
                                        <Checkbox 
                                            checked={property.id ? selectedProperties.includes(property.id) : false}
                                        />
                                        <ListItemText primary={property.name} />
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <StyledDivider 
                    sx={{
                        width: "100%",
                        justifySelf: "center"
                    }}
                />
                <Grid
                    container
                    flexDirection={"column"}
                    gap={theme.spacing(2)}
                >
                    {selectedProperties.sort((a, b) => a-b).map(propertyId => {
                        return(
                            <>
                                <TextField 
                                    label={propertyMap[propertyId].name}
                                    value={propertyValues[propertyValues.findIndex(x => x.id == propertyId  )].value}
                                    onChange={(event) => {
                                        let newPropertyValues = propertyValues;
                                        newPropertyValues[newPropertyValues.findIndex(x => x.id == propertyId)].value = event.target.value;
                                        setPropertyValues([...newPropertyValues]);
                                    }}
                                />
                            </>
                            );
                        }
                    )}
                </Grid>
                
                <Box
                    sx={{
                        marginTop: theme.spacing(2),
                        display: "flex",
                        justifyContent: "center"
                    }}
                >
                    <StyledButton
                        onClick={handleSubmit}
                        sx={{
                            width: 100
                        }}
                    >
                        Submit
                    </StyledButton>
                </Box>

            </Paper>
        </Box>
    );
}

export default LotPropertyBulkAssignPanel;